import { render, staticRenderFns } from "./photo-slider-preview-upd.vue?vue&type=template&id=806c3806&scoped=true&"
import script from "./photo-slider-preview-upd.vue?vue&type=script&lang=js&"
export * from "./photo-slider-preview-upd.vue?vue&type=script&lang=js&"
import style0 from "./photo-slider-preview-upd.vue?vue&type=style&index=0&id=806c3806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806c3806",
  null
  
)

export default component.exports